import type * as Notifications from 'expo-notifications';

export function useLastNotificationResponse(): Notifications.NotificationResponse | undefined {
  return undefined;
}
